(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-fc-track]');
    var prevBtn = root.querySelector('[data-fc-prev]');
    var nextBtn = root.querySelector('[data-fc-next]');
    var currentEl = root.closest('.fc-moods').querySelector('[data-fc-current]');
    var totalEl = root.closest('.fc-moods').querySelector('[data-fc-total]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fc-slide]'));

    if (!track || slides.length === 0) return;

    function getItemsPerView() {
      var slideWidth = slides[0].getBoundingClientRect().width;
      if (!slideWidth) return 1;
      return Math.max(1, Math.round(track.clientWidth / slideWidth));
    }

    function update() {
      var itemsPerView = getItemsPerView();
      var totalPages = Math.max(1, Math.ceil(slides.length / itemsPerView));
      var currentPage = Math.min(
        totalPages,
        Math.round(track.scrollLeft / track.clientWidth) + 1
      );

      if (totalEl) totalEl.textContent = totalPages;
      if (currentEl) currentEl.textContent = currentPage;

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) {
        nextBtn.disabled =
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
    }

    function scrollByPage(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(update, 100);
    });

    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    var carousels = document.querySelectorAll('[data-fc-carousel]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var carousel = event.target.querySelector('[data-fc-carousel]');
    if (carousel) initCarousel(carousel);
  });
})();